import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {ActionButton, ActionButtonProps} from "../../../core/components/misc/buttons/action-button";

export class ScoresListWidgetShowAllButtonProps extends BaseProps {
  onClick: Function;
  label: String;
}

export const ScoresListWidgetShowAllButton = (props: ScoresListWidgetShowAllButtonProps) => {
  const actionButtonProps: ActionButtonProps = {
    onClick: () => props.onClick(),
    className: 'scores-list-widget-show-all-button'
  };

  return (
    <ActionButton {...actionButtonProps}>
      {
        props.label
      }
    </ActionButton>
  )
};
